import { EventManager } from '../../utilities/events';
import { ContextConsumer } from '@lit/context';
import { locationListingsContext } from '../../utilities/context';
import { sidebar } from '../../utilities/styles';
export const AllInLocationListingsConsumer = (superClass) => class extends superClass {
    static properties = {
        ...super.properties,
        locations: { type: Array, state: true },
        allProvisions: { type: Array, state: true },
        location: { type: Object, state: true },
        currentZone: { type: Object, state: true },
        currentZoneID: { type: String, state: true },
        sidebar: { type: String, state: true },
        allZoneProvisions: { type: Array, state: true },
    };
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.context = new ContextConsumer(this, { context: locationListingsContext, callback: this._handleContextUpdate.bind(this), subscribe: true });
        this._context = this.context.value;
        this._populateStateFromContext();
    }
    _updateContext(props) {
        this.eventManager.emit(`allin-location-listings-${this.name}-update`, props);
    }
    _setDocumentTitle(title) {
        document.title = `${title} - All In`;
    }
    _handleContextUpdate(value) {
        this._context = value;
        this._populateStateFromContext();
    }
    _populateStateFromContext() {
        ({
            locations: this.locations,
            allProvisions: this.allProvisions,
            location: this.location,
            currentZone: this.currentZone,
            currentZoneID: this.currentZoneID,
            sidebar: this.sidebar,
            allZoneProvisions: this.allZoneProvisions,
        } = this._context);
        this._afterContextUpdate();
        this.requestUpdate();
    }
    async _afterContextUpdate() {
        // Hook for subclasses
    }
};
